const LIVE_API_URL = "https://9wadk5217c.execute-api.us-east-1.amazonaws.com";

const LOCAL_API_URL = "http://localhost:5001";

/** Live site and production builds use the live API. Localhost uses localhost:5001. Otherwise uses env or live URL. */
function getApiBaseUrl(): string {
  if (typeof window !== "undefined" && (window.location?.hostname === "localhost" || window.location?.hostname === "127.0.0.1")) {
    return LOCAL_API_URL;
  }
  if (typeof window !== "undefined" && window.location?.hostname === "dash.flcityjobs.com") {
    return LIVE_API_URL;
  }
  if (process.env.NODE_ENV === "production") {
    return LIVE_API_URL;
  }
  // SSR or dev without window - use local API when in development
  if (process.env.NODE_ENV === "development") {
    return process.env.NEXT_PUBLIC_API_BASE_URL || LOCAL_API_URL;
  }
  return process.env.NEXT_PUBLIC_API_BASE_URL || LIVE_API_URL;
}

const API_BASE_URL = getApiBaseUrl();

export const API_ENDPOINTS = {
  metrics: `${API_BASE_URL}/metrics`,
  subscriptions: `${API_BASE_URL}/jobalert/subscriptions`,
  jobseekers: `${API_BASE_URL}/jobseeker/jobseekers`,
  jobs: `${API_BASE_URL}/job/jobs`,
  company: `${API_BASE_URL}/company`,
  companyNotifications: `${API_BASE_URL}/company/notifications`,
  teamMembers: `${API_BASE_URL}/company/team-members`,
  applicants: `${API_BASE_URL}/application/applicants-with-jobseeker`,
  hiredStatus: `${API_BASE_URL}/application/hired-status`,
  // Add more endpoints as needed
};

export default API_ENDPOINTS; 